import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from '@components/Button/Button';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import Avatar from '@components/Avatar/Avatar';
import { generateAvatar } from 'utils/GlobalFunction';
import { useAppContext } from '@context/AppContext';
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";

import iconoAlert from '@assets/images/iconAlert.png';
import './Header.scss';
import { jwtDecode } from 'jwt-decode';

interface Option {
    name: string;
    active: boolean;
}

interface HeaderProps {
    options?: Option[];
}

const Header: React.FC<HeaderProps> = ({ options = [] }) => {
    const { state , dispatch } = useAppContext();
    const { user , token } = state;
    const { login ,  logout , getClaim , getOrganization } = useKindeAuth();
    const [ showModal , setShowModal ] = useState( false );
    const [ selectedOrg, setSelectedOrg ] = useState<string | null>(null);

    const handleLogout = async () => {
        localStorage.removeItem( btoa('editingPatient') )
        await logout();
        dispatch({ type: 'LOGOUT' });
    }

    const handleChangeOrg = () => {
        setShowModal(false);
        if (selectedOrg && login) {
            login({ org_code: selectedOrg });
        }
    }

    const currentOrgCode =
    typeof getOrganization === 'function' && getOrganization()
        ? getOrganization().orgCode
        : undefined;

    return <>
        <div className="tapps-header">
            <div className="tapps-header-boxes">
                <Breadcrumb links={options} />
                <div className="tapps-header-boxes-right">
                    {/* <div className="tapps-header-boxes-right-alerts">
                        <img src={iconoAlert} alt="Alerts" />
                    </div> */}
                    <div className="tapps-header-boxes-right-avatar">
                        <Avatar
                            type="name-text"
                            name={`${user?.given_name || ''} ${user?.family_name || ''}`}
                            secondText={user?.email || ''}
                            images={[
                                generateAvatar(user?.given_name || '', user?.family_name || ''),
                            ]}
                        />
                    </div>
                    <div
                        className="tapps-header-boxes-right-btnDropdownMenu"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        <i className="iconwhite-arrow-7-bottom"></i>
                    </div>
                    <ul className="dropdown-menu dropdown-menu-end">
                        <li className="dropdown-item c-pointer" onClick={() => setShowModal(true) }>Cambiar Institución</li>
                        <li className="dropdown-item c-pointer" onClick={handleLogout}>Cerrar sesión</li>
                    </ul>
                </div>
            </div>
        </div>

        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
            <div className="modalCustom">
                <h5 className="text-center">Cambiar Institución</h5>
                <p className="text-center mb-3">
                    Selecciona una opción para continuar.
                </p>
                <div>
                    {
                        (() => {
                            const claim = getClaim('organizations', "id_token");
                            if (claim && Array.isArray(claim.value)) {
                                return claim.value.map((item: any) => (
                                    <div key={item.id} style={{ marginBottom: '8px' }}>
                                        <label style={{ cursor: 'pointer' }}>
                                            <input
                                                type="radio"
                                                name="org"
                                                value={item.id}
                                                checked={selectedOrg ? selectedOrg === item.id : currentOrgCode === item.id}
                                                onChange={() => setSelectedOrg(item.id)}
                                                style={{ marginRight: '8px' }}
                                            />
                                            {item.name}
                                        </label>
                                    </div>
                                ));
                            }
                            return null;
                        })()
                    }
                </div>
                <div className={`modalCustom-buttons`}>
                    <Button
                        label="Cancelar"
                        type="secondary"
                        icon="close"
                        iconPosition="left"
                        handleClick={() => setShowModal(false)}
                    />
                    <Button
                        label="Cambiar"
                        icon="check-8"
                        iconPosition="left"
                        status="success"
                        handleClick={() => handleChangeOrg()}
                        disabled={!selectedOrg || selectedOrg === currentOrgCode}

                    />
                </div>
            </div>
        </Modal>
    </>;
};

export default Header;
